import Model from '../Model'

export default class Statistics extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/statistics'
    }
}
